import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Problems } from './components/Problems';
import { Solutions } from './components/Solutions';
import { HowItWorks } from './components/HowItWorks';
import { FeaturedRoster } from './components/FeaturedRoster';
import { Pricing } from './components/Pricing';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark text-white selection:bg-neon-cyan selection:text-dark" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Stats data-id="element-4" />
        <Problems data-id="element-5" />
        <Solutions data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <FeaturedRoster data-id="element-8" />
        <Pricing data-id="element-9" />
        <CTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}